module.exports = __webpack_public_path__ + "tc.98d2c0644c467f6abc3e.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/tc.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/tc.svg
// module chunks = styles